import styled, {css} from "styled-components";

export interface ITooltipContainerBoxStylingProps {
  backgroundColor?: string;
  textColor?: string;
  borderColor?: string;
}

interface ITooltipContainerBoxProps extends ITooltipContainerBoxStylingProps {
  active?: boolean;
}

export const TooltipContainerDefaultBox = styled.div<ITooltipContainerBoxProps>`
  @keyframes TooltipAppearAnimation {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  display: flex;
  //Hide when no active popper instance
  ${({active}) => active ? css`animation: TooltipAppearAnimation 1s ease-in;` : css`display: none;`}
        
  min-width: 330px;
  min-height: 80px;        
  
  align-items: center;

  z-index: 121; //888 drawer is 120, so we're 121
  
  background: ${({backgroundColor, theme}) => backgroundColor ? backgroundColor : theme.colors.bodyBackground};
  color: ${({textColor, theme}) => textColor ? textColor : theme.colors.bodyText};
  
  border-color:  ${({borderColor}) => borderColor ? borderColor : 'white'};
  border-width: 1px;
  border-style: solid;
  border-radius: 15px;
  
  padding: 5px;
  
  //Arrow spacing configuration
  &[data-popper-placement^='top'] > #tool-tip-container-arrow {
    bottom: -5px;
    &:before { transform: rotate(225deg) };
  }
  
  &[data-popper-placement^='bottom'] > #tool-tip-container-arrow {
    top: -5px;
  }
  
  &[data-popper-placement^='left'] > #tool-tip-container-arrow {
    right: -5px;         
    &:before { transform: rotate(125deg) };
  }
  
  &[data-popper-placement^='right'] > #tool-tip-container-arrow {
    left: -5px;         
    &:before { transform: rotate(320deg) };
  }
`;